import { useCallback } from 'react'
import { useAppDispatch } from '@/utils/typeHelpers'
import { fetchCardSummary } from './paymentMethodActions'
import type { CardSummary } from './payment-method.types'

export const useCardSummary = (): (() => Promise<CardSummary | null>) => {
  const dispatch = useAppDispatch()
  return useCallback(async () => {
    try {
      return await fetchCardSummary()(dispatch)
    } catch {
      return null
    }
  }, [dispatch])
}
